import { render, staticRenderFns } from "./AxCommunicationStep.vue?vue&type=template&id=24cceec2&scoped=true&"
import script from "./AxCommunicationStep.vue?vue&type=script&lang=js&"
export * from "./AxCommunicationStep.vue?vue&type=script&lang=js&"
import style0 from "./AxCommunicationStep.vue?vue&type=style&index=0&id=24cceec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cceec2",
  null
  
)

export default component.exports